import React, { useState } from 'react';
import { useDispatch, useSelector, batch } from 'react-redux';
import { Button, Input } from 'antd';
import DrawerModal from '../../components/shared/DrawerModal';
import styles from './AddUserToCircleModal.styles';
import {
  addUserToCircle,
  selectSelectedCircle,
} from '../../redux/store/userData/circles';
import { getIsVisibleModal, closeModal } from '../../redux/store/ui/common';
import { selectToken } from '../../redux/store/userData/user';
import { useIntl } from 'react-intl';

const AddUserToCircleModal = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const selectedCircle = useSelector(selectSelectedCircle);

  const [userEmail, setUserEmail] = useState<string>('');
  const visibleModal = useSelector(getIsVisibleModal('addUserToCircleModal'));

  const handleOnSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    batch(() => {
      dispatch(addUserToCircle(token, selectedCircle?.id!, userEmail));
      dispatch(closeModal('addUserToCircleModal'));
    });
  };

  const handleOnCancel = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dispatch(closeModal('addUserToCircleModal'));
  };

  return (
    <>
      <DrawerModal
        visible={visibleModal}
        onClose={() => {
          dispatch(closeModal('addUserToCircleModal'));
        }}
      >
        <div className="add-user-modal">
          <div className="add-user-wrapper">
            <p data-testid="AddUserToCircleModal-modalTitle" className="label">
              User email
            </p>
            <Input
              data-testid="AddUserToCircleModal-userEmailInput"
              placeholder="Type user email"
              value={userEmail}
              onChange={(e) => setUserEmail(e.target.value)}
            />
          </div>
          <Button
            data-testid="AddUserToCircleModal-addUserSubmitBtn"
            className="submit-button"
            onClick={handleOnSubmit}
          >
            {intl.formatMessage({
              id: `submit`,
            })}
          </Button>
          <Button className="cancel-button" onClick={handleOnCancel}>
            {intl.formatMessage({
              id: `cancel`,
            })}
          </Button>
        </div>
      </DrawerModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default AddUserToCircleModal;
